import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Dashboard from "./Dashboard";
import Productlist from "./Productlist";

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route>
            <Route path="/" element={<Dashboard/>} />
            <Route index path="productlist" element={<Productlist/>} />
          </Route>
        </Routes>
      </BrowserRouter>
  );
}

export default App;
